export class VehicleAddressModel {
    public id: number;
    public addressNumberId: number;
    public vehicleOwnershipId: number;
    public jurisdictionId: number;
    public countyId: number;
    public countryId: number;
    public landCategoryTypeId: number;
    public emissionAreaTypeId: number;
    public addressConfidenceRatingTypeId: number;
    public geocodeConfidenceRatingTypeId: number;
    public isMilitary: boolean;
    public inCareOf: string;
    public addressLine1: string;
    public addressLine2: string;
    public latitude: string;
    public longtitude: string;
    public city: string;
    public postalZipCode: string;
    public postalDeliveryCode: string;
    public isOveridden: boolean;
    public isUndeliverable: boolean;
    public undeliverableDate: Date;
    public addressTypeId: number;
    public isRedacted: boolean;
    public longitude: string;
    public markedAsDeleted: boolean;
}
